// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import React, {Fragment} from 'react';
// @ts-ignore
import zurl from '/util/url.js';
import cn from 'classnames';
import {Link} from 'react-router-dom';
import '../css/core/btn.less';
import {Svg} from '../ui/svg';
import {t_theme_name, use_theme} from '../settings_ctx';
import {perr} from 'hola_pub_util';

export type t_button_color = 'white'|'transparent'|'gray'|'black'|'red'
    |'rainbow'|'orange3'|'orange4'|'inactive'|'active'|'transparent_grey'
    |'accent'|'purple'|'black2023'|'purple_border'
    |'transparent_orange_border'|'transparent_orange_border2'
    |'grey2023_menu'|'transparent_black'|'line'|'light_red'|'orchid';
export type t_button_size = 'xxs'|'xs'|'sm'|'md'|'lg'|'xl';
export interface i_button_props<
    t_color = t_button_color,
    t_size = t_button_size,
    > {
    to?: string;
    on_click?: (ev?:React.MouseEvent)=>void;
    on_blur?: (ev?:React.MouseEvent)=>void;
    caption: string|JSX.Element;
    cls?: string;
    round?: boolean;
    size?: t_size;
    color?: t_color;
    w100?: boolean;
    disabled?: boolean;
    width?: number;
    arrow?: boolean;
    target?: string;
    clickid?: string;
    tab_index?: string;
    click_around?: boolean;
    icon?: JSX.Element;
    icon_left?: JSX.Element;
    icon_right?: JSX.Element;
    no_padding?: boolean;
    align_left?: boolean;
    dropdown?: boolean;
    opened?: boolean;
    no_jump?: boolean;
    no_action?: boolean;
    inline?: boolean;
    as_external?: boolean;
    reverse?: boolean;
    txt_colored?: boolean;
    theme?: t_theme_name;
    fit?: boolean;
    inherit_width?: boolean;
}
export const Button = React.forwardRef(<
    t_color extends string = t_button_color,
    t_size extends string = t_button_size,
    >({to, arrow,
    caption, cls, on_click, on_blur, round=true, size,
    color, w100, disabled, target, width, clickid, tab_index, click_around,
    icon, no_padding, align_left, dropdown, opened, no_jump=true,
    no_action, inline, as_external, reverse, txt_colored,
    icon_left, icon_right, theme, fit, inherit_width}
    :Omit<i_button_props<t_color, t_size>, 'ref'>,
    ref: React.Ref<HTMLButtonElement>)=>
{
    const {theme_name} = use_theme();
    const is_hola2023 = theme_name=='hola2023' || theme=='hola2023';
    const is_toolip = theme_name=='toolip';
    const on_click_hdl = ev=>{
        if (is_toolip)
        {
            const text = ev.target.innerText || 'empty';
            const id = text.replace(/[ .,!-]/g, '_')
                .replace(/[^A-Za-z0-9_]/ig, '').toLowerCase();
            perr({id: `toolip_button_click_${id}`});
        }
        if (on_click)
            return on_click(ev);
    };
    if (!color && !txt_colored && is_hola2023)
        color = 'black2023' as t_color;
    if (color=='black' && is_hola2023)
        color = 'black2023' as t_color;
    if (is_toolip && !color)
        color = 'black' as t_color;
    const is_external = as_external || !!zurl.parse(to).host;
    let Root:any = 'button';
    const link_props:object_of<string> = {};
    if (to)
    {
        Root = is_external ? 'a' : Link;
        if (is_external)
        {
            if (to.includes('.exe') && !is_toolip)
            {
                const parsed = zurl.parse(to, true);
                link_props.href = `https://${window.location.host}`+
                    '/download_win'+parsed.search+
                    '&file='+parsed.file.split('.exe')[0]+
                    '&v='+(parsed.directory.includes('2') ? '2' : '1');
            }
            else
                link_props.href = to;
            if (target=='_blank')
            {
                link_props.target = '_blank';
                link_props.rel = 'noopener noreferrer';
            }
        }
        else
            link_props.to = to;
    }
    const Internal_wrapper = arrow || color == 'black2023' || txt_colored ?
        'span' : Fragment;
    const btn_cls = cn('hola_btn', round && 'hola_btn--round',
        inline && 'hola_btn--inline', reverse && 'hola_btn--reverse',
        w100 && 'hola_btn--w100', color && `hola_btn--${color}`,
        size && `hola_btn--${size}`, !caption && 'hola_btn--empty_caption',
        no_padding && 'hola_btn--no_padding', align_left && 'hola_btn--left',
        dropdown && 'hola_btn--dropdown',
        fit && 'hola_btn--fit',
        inherit_width && 'hola_btn--inherit_width',
        opened && 'hola_btn--dropdown_opened',
        (no_jump || is_hola2023) && 'hola_btn--no_jump',
        no_action && 'hola_btn--no_action',
        !arrow && 'hola_btn-no_arrow',
        txt_colored && 'hola_btn--txt_colored', cls,
        is_toolip && 'toolip_btn');
    const aria_label = typeof caption == 'string' && (!caption || icon ||
        icon_left || icon_right) ? caption : undefined;
    // XXX dmitriiz: icons in sets have to be with 0 0 16 16 viewBox
    return <Root onClick={on_click_hdl} disabled={disabled || false}
      ref={ref} onBlur={on_blur}
      className={btn_cls} {...link_props}
      style={width ? {width: `${width}px`} : {}}
      data-clickid={clickid} tabIndex={tab_index} aria-label={aria_label}>
      <Internal_wrapper>
        {icon && <Svg icon={icon} cls={'hola_btn_icon'}/>}
        {icon_left}{caption}{icon_right}
      </Internal_wrapper>
      {click_around && <div className="btn_area_for_click"></div>}
    </Root>;
});
